import {
  WAPP_COMMUNICATE_CORE_SEND_MESSAGE,
  wappCommunicateCoreSendMessage,
} from '@weblite/wapp-communication-action/core'
import { getWapp } from '$logic/wapps/service'
import { shareInlineWapp } from '$logic/wapp-communication/helper/utils.helper'
import { sendOldActionToWapp } from '$logic/wapp-communication/wapp-communication.publish'
import { wappSub } from '$func/subscription'

wappSub.subscribe(
  WAPP_COMMUNICATE_CORE_SEND_MESSAGE,
  async ({ payload, meta }) => {
    const { type, content } = payload
    if (type !== 'wapp') return

    const { wappId, wisId, customize, width, height } = content || {}

    const wapp = await getWapp(wappId)
    if (!wapp) {
      sendOldActionToWapp(
        wappCommunicateCoreSendMessage({ wisId: undefined }),
        meta,
      )

      return
    }

    const { width: defaultWidth, height: defaultHeight } = wapp
    const sharedWisId = await shareInlineWapp(
      {
        wappId,
        wisId,
        input: customize,
        width: width ?? defaultWidth,
        height: height ?? defaultHeight,
      },
      false,
    )

    sendOldActionToWapp(
      wappCommunicateCoreSendMessage({ wisId: sharedWisId }),
      meta,
    )
  },
  true,
)
